export default "/images/icons8-hungary.png?165d3e0eceb5577e8c20c1f1414a27cd";